// client/pages/Index.tsx
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTheme } from "@/contexts/ThemeContext";

// ========== Animation Styles (same as Dashboard) ==========
const animationStyles = `
  @keyframes spin-slow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes spin-slow-reverse {
    from { transform: rotate(360deg); }
    to { transform: rotate(0deg); }
  }
  @keyframes spin-slower {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes pulse-logo {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
  }
  .animate-spin-slow {
    animation: spin-slow 8s linear infinite;
  }
  .animate-spin-slow-reverse {
    animation: spin-slow-reverse 6s linear infinite;
  }
  .animate-spin-slower {
    animation: spin-slower 10s linear infinite;
  }
  .animate-pulse-logo {
    animation: pulse-logo 2s ease-in-out infinite;
  }
`;

export default function Index() {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const [loading, setLoading] = useState(true);

  // ============ SAME LOGIC AS IN Header.tsx ============
  const fetchUserFromSession = async (retryCount = 0) => {
    try {
      const response = await fetch("/api/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.user) {
          navigate("/dashboard", { replace: true });
          return;
        } else {
          if (retryCount < 1) {
            setTimeout(() => fetchUserFromSession(retryCount + 1), 100);
          } else {
            setLoading(false);
          }
        }
      } else if (response.status === 401) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("[Index] Session fetch error:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserFromSession();
  }, [navigate]);
  // =====================================================

  const handleGetStartedClick = () => {
    navigate("/dashboard");
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4"></div>
          <p className="text-muted-foreground">LOADING...</p>
        </div>
      </div>
    );
  }

  // If not logged in, show the landing page
  return (
    <div className="min-h-screen bg-background flex flex-col p-4 md:p-8">
      <style>{animationStyles}</style>
      <div className="w-full max-w-lg flex flex-col mx-auto min-h-[calc(100vh-2rem)]">
        {/* Minimal spacer to push content up */}
        <div className="flex-1 max-h-[5%]"></div>
        
        {/* Animation - Only the rotating rings with logo */}
        <div className="w-full mb-12 flex justify-center">
          <div className="relative w-[200px] h-[200px]">
            <div className="absolute inset-0 rounded-full border-[5px] border-transparent border-t-[#00D4FF] border-r-[#00D4FF]/30 animate-spin-slow" />
            <div className="absolute inset-[12%] rounded-full border-[5px] border-transparent border-b-[#9945FF] border-l-[#9945FF]/30 animate-spin-slow-reverse" />
            <div className="absolute inset-[24%] rounded-full border-[5px] border-transparent border-t-[#F3BA2F] border-r-[#F3BA2F]/30 animate-spin-slower" />
            <div className="absolute inset-[15%] rounded-full bg-white dark:bg-gray-800 shadow-2xl flex items-center justify-center animate-pulse-logo overflow-hidden">
              <img 
                src="https://i.postimg.cc/nhLMdyVM/favicon.png" 
                alt="Fixorium" 
                className="w-full h-full object-contain p-3"
              />
            </div>
          </div>
        </div>

        {/* Text and Buttons - Increased gap from animation */}
        <div className="w-full space-y-6 pb-0">
          <div className="text-center">
            <h3 className="text-foreground text-xl font-semibold mb-2 uppercase">GET STARTED</h3>
            <p className="text-muted-foreground text-sm uppercase">BUY CRYPTO WITH SECURE PLATFORM</p>
          </div>
          <div className="space-y-4">
            <button
              onClick={handleGetStartedClick}
              className="w-full bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-black font-bold py-3 md:py-4 px-6 rounded-lg transition-all duration-300 text-sm md:text-base uppercase tracking-wider shadow-lg hover:shadow-xl"
            >
              LOGIN NOW
            </button>
            <button
              onClick={handleSignupClick}
              className="w-full bg-muted hover:bg-muted/80 text-foreground font-bold py-3 md:py-4 px-6 rounded-lg transition-all duration-300 text-sm md:text-base uppercase tracking-wider border border-border"
            >
              CREATE ACCOUNT
            </button>
          </div>
          {/* Increased bottom gap */}
          <div className="pt-12"></div>
        </div>
      </div>
    </div>
  );
}
